import { IGameState } from '../../Game/IGameState';
import BaseCardBehavior from './BaseCardBehavior';

export default class LockCardBehavior extends BaseCardBehavior {
    public isPlayable(state: IGameState): boolean {
        return false;
    }
}
